export default function (Component) {
Component.options.__tip = "<p>You have to embed a <code>FdShellBar</code> in a <code>FdShell</code> for things to work properly.</p>\n"
}